<div class="overflow-auto w-full h-full pb-20 bg-gray-50 font-prompt mx-auto">
  <div
    class="w-full bg-(--header-background) px-4 py-3 flex items-center justify-between sticky top-0 z-30 shadow-sm text-white select-none">
    <button type="button" (click)="goBack()"
      class="flex items-center text-white hover:opacity-80 active:scale-95 transition-all outline-none">
      <img src="icons/arrow_back_white.svg" alt="back" />
    </button>
    <h1 class="text-sm font-bold tracking-wide m-0">
      <ng-container *ngIf="!lotRef">{{ currentLang === 'TH' ? 'ข่าวสารทั้งหมด' : 'All News' }}</ng-container>
      <ng-container *ngIf="lotRef">{{ currentLang === 'TH' ? 'ประกาศจากลาน' : 'Parking lot news' }}{{ lotName ? ' · ' + lotName : '' }}</ng-container>
    </h1>
    <div class="w-6"></div>
  </div>

  <div class="px-4 pt-4 space-y-3">
    <div *ngIf="!isLoading && items.length === 0"
      class="bg-white rounded-2xl p-8 text-center border border-gray-100 shadow-sm">
      <div class="w-14 h-14 mx-auto mb-3 rounded-full bg-amber-50 flex items-center justify-center">
        <img src="icons/notifications_orange.svg" alt="empty" class="w-6 h-6 opacity-70" />
      </div>
      <p class="text-sm font-bold text-slate-700">
        {{ currentLang === 'TH' ? 'ยังไม่มีข่าวสาร' : 'No news yet' }}
      </p>
    </div>

    <button type="button" *ngFor="let item of items" (click)="openDetail(item.id)"
      class="w-full text-left bg-white rounded-2xl overflow-hidden border border-gray-100 shadow-sm hover:shadow-md active:scale-[0.99] transition-all cursor-pointer">
      <div class="w-full h-36 bg-slate-100 overflow-hidden" *ngIf="item.coverImageUrl">
        <img [src]="item.coverImageUrl" [alt]="titleOf(item)" class="w-full h-full object-cover" />
      </div>
      <div class="p-3.5">
        <div class="flex items-center gap-2 mb-1.5 flex-wrap">
          <span *ngIf="item.pin"
            class="px-2 py-0.5 rounded-lg bg-amber-100 text-amber-700 text-[10px] font-bold">
            {{ currentLang === 'TH' ? 'ปักหมุด' : 'Pinned' }}
          </span>
          <span *ngIf="item.categoryName"
            class="px-2 py-0.5 rounded-lg bg-slate-100 text-slate-600 text-[10px] font-bold">
            {{ item.categoryName }}
          </span>
          <span *ngIf="!item.siteId"
            class="px-2 py-0.5 rounded-lg bg-sky-50 text-sky-700 text-[10px] font-bold">
            City Parking
          </span>
          <span *ngIf="item.siteId && !lotRef"
            class="px-2 py-0.5 rounded-lg bg-emerald-50 text-emerald-700 text-[10px] font-bold">
            {{ currentLang === 'TH' ? 'ประกาศจากลาน' : 'From lot' }}{{ item.siteName ? ' · ' + item.siteName : '' }}
          </span>
        </div>
        <h3 class="text-sm font-bold text-slate-800 line-clamp-2">{{ titleOf(item) }}</h3>
        <p *ngIf="item.summary" class="text-xs text-slate-500 mt-1 line-clamp-2">{{ item.summary }}</p>
        <p *ngIf="item.publishFrom" class="text-[10px] text-slate-400 mt-2">{{ formatDate(item.publishFrom) }}</p>
      </div>
    </button>

    <button *ngIf="hasMore" type="button" (click)="loadMore()" [disabled]="isLoadingMore"
      class="w-full py-3 rounded-2xl bg-white border border-amber-200 text-amber-600 text-xs font-bold hover:bg-amber-50 active:scale-[0.99] transition-all disabled:opacity-60">
      {{ isLoadingMore
        ? (currentLang === 'TH' ? 'กำลังโหลด...' : 'Loading...')
        : (currentLang === 'TH' ? 'โหลดเพิ่ม' : 'Load more') }}
    </button>
  </div>
</div>

<app-pss-loading *ngIf="isLoading"></app-pss-loading>
